import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useTranslation } from "react-i18next";
import { sizedImage } from "@/lib/imageUtils";

const SPANS = ["col-span-2 md:col-span-2 md:row-span-2", "md:col-span-2", "", "", "md:col-span-2", "md:col-span-2", "md:col-span-4"];

// Big photo tiles for the farm's areas (shop, experiences, restaurant...).
export const AreasBento = ({ sections }) => {
  const { i18n } = useTranslation();
  const isIt = i18n.language === "it";
  return (
    <section data-reveal className="py-16 md:py-24 bg-[#f6f3ec]" data-testid="home-areas">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="mb-10 max-w-2xl">
          <p className="text-sm uppercase tracking-[0.2em] text-[#7e823a] font-semibold mb-3">{isIt ? "Vivi Sadira" : "Experience Sadira"}</p>
          <h2 className="text-4xl md:text-5xl font-bold text-[#2C2C2C]" style={{ fontFamily: "'Playfair Display', serif" }}>
            {isIt ? "Un agriturismo, tanti modi di viverlo" : "One farm, many ways to enjoy it"}
          </h2>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 auto-rows-[170px] md:auto-rows-[230px] gap-3 md:gap-4">
          {sections.map((s, i) => (
            <Link
              key={s.href}
              to={s.href}
              className={`bento-tile group relative rounded-3xl overflow-hidden bg-[#556B2F] shadow-sm hover:shadow-xl transition-shadow duration-300 ${SPANS[i] || ""}`}
              data-testid={`section-${s.href.replace(/^\//, "") || "home"}`}
            >
              {s.image && <img src={sizedImage(s.image, 800)} alt={s.label} loading="lazy" decoding="async" className="absolute inset-0 w-full h-full object-cover" style={{ objectPosition: `50% ${s.positionY ?? 50}%` }} />}
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/15 to-transparent" />
              <div className="absolute bottom-0 inset-x-0 p-4 md:p-6 flex items-end justify-between gap-2">
                <span className={`text-white font-semibold leading-tight ${i === 0 ? "text-2xl md:text-4xl" : "text-lg md:text-2xl"}`} style={{ fontFamily: "'Playfair Display', serif" }}>
                  {s.label}
                </span>
                <span className="w-9 h-9 md:w-10 md:h-10 rounded-full bg-white/90 text-[#2C2C2C] flex items-center justify-center flex-shrink-0 transition-transform duration-300 group-hover:rotate-45">
                  <ArrowUpRight className="w-4 h-4 md:w-5 md:h-5" />
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AreasBento;
